import { createQueryString } from '~/domains/common/utils/queryString';

export const mailToSupport = ({
  subject,
  body,
}: {
  subject?: string;
  body?: string;
} = {}) => {
  const url = `mailto:support@splashsports.com${createQueryString({
    body,
    subject,
  }).replace(/\+/g, '%20')}`;

  window.location.href = url;
};
